/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { SendMessage1MutationRequest, SendMessage1MutationResponse, SendMessage1PathParams, SendMessage1400, SendMessage1401, SendMessage1403, SendMessage1404, SendMessage1409, SendMessage1500 } from "../../types/SendMessage1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getSendMessage1Url(sessionId: SendMessage1PathParams["sessionId"]) {
  const res = { method: 'POST', url: `/api/research-chat/${sessionId}/message` as const }
  return res
}

/**
 * @description Creates a user message and initiates async AI processing. Returns immediately with the assistant message ID for polling.
 * @summary Send a message to a research chat session
 * {@link /api/research-chat/:sessionId/message}
 */
export async function sendMessage1(sessionId: SendMessage1PathParams["sessionId"], data: SendMessage1MutationRequest, config: Partial<RequestConfig<SendMessage1MutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SendMessage1MutationResponse, ResponseErrorConfig<SendMessage1400 | SendMessage1401 | SendMessage1403 | SendMessage1404 | SendMessage1409 | SendMessage1500>, SendMessage1MutationRequest>({ method : "POST", url : getSendMessage1Url(sessionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}